import {useState} from 'react';

import {makeGetCheckRequestProtocol, makeGetRequestProtocolPdf} from 'main/factories/usecases';
import {OperationStateTypesEnum, UserTypeEnum} from 'presentation/constants';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {getUserInfoFromToken} from 'presentation/utils';

export function useGetRefundPdf() {
	const {beneficiary} = useAccountDataStore(store => store.accountData);
	const isHolder = beneficiary.tipoUsuarioC === UserTypeEnum.HOLDER;
	const userCode = getUserInfoFromToken().cdUsuario;

	const [downloadPdfoperationState, setDownloadPdfOperationState] = useState(
		OperationStateTypesEnum.NONE,
	);
	const [checkRequestOperationState, setCheckRequestOperationState] = useState(
		OperationStateTypesEnum.NONE,
	);

	async function downloadPdf(protocol: string) {
		try {
			setDownloadPdfOperationState(OperationStateTypesEnum.SUBMITTING);
			const response = await makeGetRequestProtocolPdf().get({
				protocol,
				'patient-code': isHolder ? undefined : userCode,
			});

			window.open(response.content.url, '_blank');
			setDownloadPdfOperationState(OperationStateTypesEnum.DONE);
		} catch (error) {
			setDownloadPdfOperationState(OperationStateTypesEnum.ERROR);
		}
	}

	const checkRequest = async (protocol: string) => {
		try {
			setCheckRequestOperationState(OperationStateTypesEnum.SUBMITTING);
			const response = await makeGetCheckRequestProtocol().get({
				protocol,
				'patient-code': isHolder ? undefined : userCode,
			});
			window.open(response.content.url, '_blank');
			setCheckRequestOperationState(OperationStateTypesEnum.DONE);
		} catch (error) {
			setCheckRequestOperationState(OperationStateTypesEnum.ERROR);
		}
	};

	const DOWNLOAD_PDF_IS_LOADING =
		downloadPdfoperationState === OperationStateTypesEnum.SUBMITTING;
	const DOWNLOAD_PDF_IS_ERROR = downloadPdfoperationState === OperationStateTypesEnum.ERROR;
	const CHECK_REQUEST_IS_LOADING =
		checkRequestOperationState === OperationStateTypesEnum.SUBMITTING;
	const CHECK_REQUEST_IS_ERROR = checkRequestOperationState === OperationStateTypesEnum.ERROR;

	return {
		DOWNLOAD_PDF_IS_LOADING,
		setDownloadPdfOperationState,
		DOWNLOAD_PDF_IS_ERROR,
		CHECK_REQUEST_IS_ERROR,
		setCheckRequestOperationState,
		CHECK_REQUEST_IS_LOADING,
		downloadPdf,
		checkRequest,
	};
}
